// Bar-chart grow-on-scroll: pure transform: scaleX animation triggered by
// adding .bar-grow-anim. Widths are never touched — bars stay at their
// server-rendered inline widths in all cases, so data is always visible.
(function () {
  'use strict';

  const BAR_SELECTOR = '[class*="ai-bar-chart__bar-"]';
  const CHART_SELECTOR = '[class*="ai-bar-chart-"]:not([class*="ai-bar-chart__"])';
  const STAGGER_MS = 280;

  const charts = document.querySelectorAll(CHART_SELECTOR);
  if (charts.length === 0) return;

  const prefersReducedMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  function growChart(chart) {
    if (chart.dataset.barChartGrown === '1') return;
    chart.dataset.barChartGrown = '1';
    chart.querySelectorAll(BAR_SELECTOR).forEach(function (bar, i) {
      bar.style.setProperty('--bar-grow-delay', i * STAGGER_MS + 'ms');
      bar.classList.add('bar-grow-anim');
    });
  }

  function isAlreadyVisible(el) {
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < vh && rect.bottom > 0;
  }

  if (!('IntersectionObserver' in window)) {
    charts.forEach(growChart);
    return;
  }

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        growChart(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });

  charts.forEach(function (chart) {
    if (isAlreadyVisible(chart)) {
      growChart(chart);
    } else {
      observer.observe(chart);
    }
  });
})();
